import { Avatar, AvatarGroup } from "@mui/material";
import React from "react";

interface ToolIntegrationLogosProps {
  size?: "small" | "medium";
  max?: number;
}

const TOOL_LOGOS = [
  { src: "https://logos.composio.dev/api/gmail", alt: "Gmail" },
  { src: "https://logos.composio.dev/api/slack", alt: "Slack" },
  { src: "https://logos.composio.dev/api/notion", alt: "Notion" },
  { src: "https://logos.composio.dev/api/hubspot", alt: "HubSpot" },
  { src: "https://logos.composio.dev/api/salesforce", alt: "Salesforce" },
  { src: "https://logos.composio.dev/api/jira", alt: "Jira" },
  { src: "https://logos.composio.dev/api/asana", alt: "Asana" },
  { src: "https://logos.composio.dev/api/zendesk", alt: "Zendesk" },
  { src: "https://logos.composio.dev/api/linear", alt: "Linear" },
  { src: "https://logos.composio.dev/api/googlecalendar", alt: "Google Calendar" },
];

export default function ToolIntegrationLogos({
  size = "medium",
  max = 10,
}: ToolIntegrationLogosProps) {
  const avatarSize = size === "small" ? 24 : 32;
  const fontSize = size === "small" ? 10 : 12;

  return (
    <AvatarGroup
      max={max}
      sx={{
        "& .MuiAvatar-root": {
          width: avatarSize,
          height: avatarSize,
          fontSize,
          bgcolor: "background.paper",
          color: "text.primary",
          border: "none",
        },
      }}
    >
      {TOOL_LOGOS.map((logo) => (
        <Avatar key={logo.alt} src={logo.src} alt={logo.alt} />
      ))}
    </AvatarGroup>
  );
}
